module.exports = __webpack_public_path__ + "html/explainer_06a0bf06befe492b8cb4ea6685b82e99.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/explainer.html
// module id = v09R
// module chunks = 154